/*
 * @overview: 捕获网页中的 JavaScript 异常和资源加载异常，并将异常信息上报到服务端进行记录和分析
 * @Created by: zhuyikai
 * @Copyright: Copyright © 2020 找我婚礼. All rights reserved.
 * @Date: 2023-03-27 16:57:28
 */

import ErrorStackParser from "error-stack-parser";
import getLastEvent from "../utils/getLastEvent";
import { tracker, options } from "../core";
import { EVENTTYPES, ERRORTYPES, RESOURCEMAP } from "../const";

export function injectJsError(Vue) {
  // vue项目在Vue.config.errorHandler中上报错误
  if (Vue) {
    Vue.config.errorHandler = function (error, vm, info) {
      handleError(error, "VUE", "VUE_ERROR");
    };
  }
  // 全局捕获普通 JS 异常
  window.addEventListener(
    "error",
    (e) => {
      handleError(e, "ERROR", "JAVASCRIPT_ERROR");
    },
    true
  );
  // 全局捕获 Promise 异常
  window.addEventListener("unhandledrejection", function (e) {
    try {
      let lastEvent = getLastEvent(); // 获取最后一个交互事件
      let stackFrame = ErrorStackParser.parse(e.reason)[0];
      let { fileName, columnNumber, lineNumber } = stackFrame;
      let log = {
        type: EVENTTYPES.UNHANDLEDREJECTION,
        errorType: ERRORTYPES.PROMISE_ERROR,
        message: e.reason.message,
        filename: fileName,
        line: lineNumber,
        column: columnNumber,
        // selector: lastEvent
        //   ? (lastEvent.target && lastEvent.target.outerHTML) || ""
        //   : "", // 最后一个操作元素
      };
      if (Date.now() - options.apiSending < 3000) return;
      tracker.send(log);
    } catch (error) {
      console.error("webcrawling: unhandledrejection错误解析异常:", error);
    }
  });
}

const handleError = (e, type, errorType) => {
  try {
    let lastEvent = getLastEvent(); // 获取最后一个交互事件
    const target = e.target;
    let log = null;
    if (!target || (e.target && !e.target.localName)) {
      let { fileName, columnNumber, lineNumber } = ErrorStackParser.parse(
        !target ? e : e.error
      )[0];
      log = {
        type: EVENTTYPES[type],
        errorType: ERRORTYPES[errorType],
        message: e.message,
        filename: fileName,
        line: lineNumber,
        column: columnNumber,
        // selector: lastEvent
        //   ? (lastEvent.target && lastEvent.target.outerHTML) || ""
        //   : "", // 最后一个操作元素
      };
    }

    // 资源加载报错
    if (target && target.localName) {
      // 提取资源加载的信息
      const interceptStr = (str, interceptLength) => {
        if (typeof str === "string") {
          return (
            str.slice(0, interceptLength) +
            (str.length > interceptLength
              ? `:截取前${interceptLength}个字符`
              : "")
          );
        }
        return "";
      };
      log = {
        type: EVENTTYPES.RESOURCE,
        errorType: EVENTTYPES.RESOURCE_ERROR,
        message:
          (interceptStr(target.src, 120) || interceptStr(target.href, 120)) +
          "; 资源加载失败",
        filename: `${RESOURCEMAP[target.localName] || target.localName}`,
      };
    }
    if (Date.now() - options.apiSending < 3000) return;
    log && tracker.send(log);
  } catch (error) {
    console.error("webcrawling: error错误解析异常:", error);
  }
};
